import { useNavigation } from 'react-router'

export function NavigationProgress() {
  const navigation = useNavigation()
  if (navigation.state === 'idle') return null

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-x-0 top-0 z-[200] h-0.5 overflow-hidden"
    >
      <div className="nav-progress-bar h-full w-full bg-[var(--color-brand-accent)] shadow-[0_0_12px_rgba(0,229,255,0.8)]" />
    </div>
  )
}
